






















































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import SensorDesk from '@/views/dashboard/sensorDesk/SensorDesk.vue';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import {SystemNode} from '@/components/system/interfaces';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import FacilityStructureTree from '@v/dashboard/FacilityStructureTree.vue';
import FacilityStructureTreeHelp from '@v/dashboard/FacilityStructureTreeHelp.vue';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import NodeComponent from '@/components/nodeComponent/NodeComponent.vue';
import {NodeData} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';
import NodesTree from '@c/nodesTree/NodesTree.vue';
import NodesTreeCheckBox from '@c/nodesTree/NodesTreeCheckBox.vue';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import ProblemLog from '@v/dashboard//ProblemLog.vue';
import {httpClient} from '@api/baseApi';

@Component({
  components: {
    SensorDesk,
    Splitpanes,
    Pane,
    Breadcrumbs,
    FacilityStructureTree,
    FacilityStructureTreeHelp,
    NodeComponent,
    NodesTree,
    Loading,
    SimpleDialog,
    NodesTreeCheckBox,
    ProblemLog,
  },
})
export default class DesktopDashboard extends Vue {
  // Ключ для перерисовки компоненты узла
  key = 0;

  // Ключ для перерисовки компоненты структуры предприятия
  treeResizedKey = 0;

  // Выбранный путь в дереве структуры предприятия
  nodesPath: SystemNode[] = [];

  // Список элементов для выбора
  nodes: NodeData[] = [];

  selectedNodeModel: NodeData | null = null;

  // Модель диалогового окна
  dialog = false;
  settingsDialog = false;

  // Показатели загрузки и наличия ошибок
  loading = false;
  error = false;
  presetLoading = false;

  showWeekWorkload = false;
  showDayWorkload = true;

  showNodeNumbers = false;

  showWeekWorkloadValue = false;
  showDayWorkloadValue = true;

  horizontalPaneSize: any = null;
  verticalPaneTreeSize: any = null;
  verticalPaneLogSize: any = null;

  dataStream: any = [];
  dataStreamModel: any = null;
  dataStreamModelTitle = '';

  // Объект виджета
  @Prop({required: false})
  measurements!: MeasurementData;

  // признак окончания построения загруженности
  @Prop()
  creatingFinishedFlag!: boolean;

  // Модель для выбранных элементов
  selectedNodes: any = null;

  // массив ids выбранных элементов
  checkedItemsId: string[] = [];

  // массив ids выбранных элементов
  selNodesInDB: string[] = [];

  // Выбранный узел в дереве структуры предприятия
  get selectedNode() {
    this.key++;
    if (!this.nodesPath.length) return null;

    return this.nodesPath[this.nodesPath.length - 1];
  }

  get canSelect() {
    return this.selectedNodeModel != null;
  }

  reloadTree() {
    (this.$refs.facilityTree as any).updateTree();
  }

  getBoundaries() {
    return (this.$refs.facilityTree as any).getBoundaries();
  }

  changeTreeSettings() {
    this.showDayWorkload = this.showDayWorkloadValue;
    this.showWeekWorkload = this.showWeekWorkloadValue;
    const settings = {
      showDayWorkload: this.showDayWorkload,
      showWeekWorkload: this.showWeekWorkload,
      showNodeNumbers: this.showNodeNumbers,
      dataStreamModel: this.dataStreamModel,
    };
    (this.$refs.facilityTree as any).updateTree(this.showDayWorkload, this.showWeekWorkload);
    userSettingsStoreModule.setTreeSettings(settings);
  }

  getDataStreamModelTitle(value: string): string {
    return this.dataStream.find((item: any) => item.type === value)?.description ?? '';
  }

  // Загрузка дерева
  async loadTree() {
    try {
      this.loading = true;
      await nodeModule.fetchAll();
      this.nodes = [...nodeModule.all];
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
      this.presetLoading = false;
    }
  }

  @Watch('dialog')
  onDialog(value: boolean) {
    if (value && !this.nodes.length) {
      this.loading = true;
      this.loadTree();
    }
  }

  @Watch('dataStreamModel')
  async onDataStreamModel(val: string) {
    this.dataStreamModelTitle = this.getDataStreamModelTitle(val);
  }

  created() {
    this.getFacStr();
    this.getTreeSettings();
    this.getPaneSizes();
    if (this.selectedNodes?.length) {
      this.presetLoading = true;
      this.loadTree();
    }
    this.setStreamFilter(this.dataStreamModel);
  }

  async getTreeSettings() {
    const settings = localStorage.getItem('treeSettings');
    if (settings) {
      const data = JSON.parse(settings);
      this.showDayWorkload = data.showDayWorkload;
      this.showWeekWorkload = data.showWeekWorkload;
      this.showDayWorkloadValue = data.showDayWorkload;
      this.showWeekWorkloadValue = data.showWeekWorkload;
      this.showNodeNumbers = data.showNodeNumbers;
      this.dataStreamModel = data.dataStreamModel;
    }
  }

  getPaneSizes() {
    const settings = localStorage.getItem('dashboardPaneSizes');
    if (settings) {
      const data = JSON.parse(settings);
      this.horizontalPaneSize = data.horizontalPaneSize;
      this.verticalPaneTreeSize = data.verticalPaneTreeSize;
      this.verticalPaneLogSize = data.verticalPaneLogSize;
    } else {
      this.horizontalPaneSize = '50';
      this.verticalPaneTreeSize = '60';
      this.verticalPaneLogSize = '50';
    }
  }

  async getFacStr() {
    const facStr = await userSettingsStoreModule.getFacStr();
    if (facStr && this.selectedNodes != facStr) this.selectedNodes = facStr;
  }

  // Действия при выборе элемента
  onSelect() {
    this.selectedNodes = this.checkedItemsId;
    userSettingsStoreModule.saveFacStrMutation(this.selectedNodes);
  }

  // Действия при изменении выбранного узла в компоненте узла
  onChangeNode(item: SystemNode) {
    const nodeIndex = this.nodesPath.findIndex(x => x.id === item.id);
    const copiedNodesPath = [...this.nodesPath];
    if (nodeIndex !== -1) copiedNodesPath.length = nodeIndex + 1;
    else copiedNodesPath.push(item);
    this.nodesPath = copiedNodesPath;
    this.key++;
  }

  onHorizontalPaneResized(e: any) {
    this.horizontalPaneSize = e[0].size;
    const settings = {
      horizontalPaneSize: this.horizontalPaneSize,
      verticalPaneTreeSize: this.verticalPaneTreeSize,
      verticalPaneLogSize: this.verticalPaneLogSize,
    };
    userSettingsStoreModule.setDashboardPaneSizes(settings);
  }

  // Действия при изменении размера pane с деревом структуры предприятия
  onTreePaneResized(e: any) {
    this.verticalPaneTreeSize = e[0].size;
    const settings = {
      horizontalPaneSize: this.horizontalPaneSize,
      verticalPaneTreeSize: this.verticalPaneTreeSize,
      verticalPaneLogSize: this.verticalPaneLogSize,
    };
    userSettingsStoreModule.setDashboardPaneSizes(settings);
    this.treeResizedKey++;
  }

  onLogPaneResized(e: any) {
    this.verticalPaneLogSize = e[0].size;
    const settings = {
      horizontalPaneSize: this.horizontalPaneSize,
      verticalPaneTreeSize: this.verticalPaneTreeSize,
      verticalPaneLogSize: this.verticalPaneLogSize,
    };
    userSettingsStoreModule.setDashboardPaneSizes(settings);
    (this.$refs.sensorDesk as any).paneSizeChanged();
  }

  async setStreamFilter(value: any) {
    const {data} = await httpClient.get<[]>(`module_types/`);
    this.dataStream = data.map((x: any) => {
      return {
        value: x.value,
        description: x.description,
        type: x.type,
      };
    });
    this.dataStreamModel = value;
    this.dataStreamModelTitle = this.getDataStreamModelTitle(value);
  }

  mounted() {
    const size = 100 - this.verticalPaneLogSize;
    const dashboardWidth = (this.$refs.dashboard as any).offsetWidth;
    (this.$refs.sensorDesk as any).paneSizeChanged(Math.round((dashboardWidth * size) / 100) - 150);
    //хак для обновления диаграммы, после ресайза сплиттера. Событие @ready на сплиттере не работает, т. к. не синхронизированно с vuetify
    this.$nextTick(() => {
      this.treeResizedKey++;
    });
  }

  // получение массива выбранных id с формы настроек отображения структуры предприятия
  selectedIds(selected: any[]) {
    this.checkedItemsId = selected;
  }
}
